import { requestAuthAdmin } from './auth';
import { getSelectedEnvironment } from '../utils/apiEnvironment';
export const SPORTS_SEASONS_PATH = '/api-admin/v1/sports/seasons';
export function sportsEndpoint(environment) {
  if (environment !== 'test') return null;
  return `${process.env.REACT_APP_AUTH_ADMIN_TEST_URL || 'https://test-auth-admin.fancian.net'}${SPORTS_SEASONS_PATH}`;
}
async function request(path, options, token, environment) {
  if (environment !== 'test' || getSelectedEnvironment() !== environment) throw new Error('Sports schedules are available only in the selected TEST environment.');
  const response = await requestAuthAdmin(`${path}?environment=${environment}`, options, token);
  let body;
  try { body = await response.json(); } catch { throw new Error(`Sports response unavailable (${response.status})`); }
  if (!response.ok) {
    const error = new Error(body?.msg || `Sports request failed (${response.status})`);
    error.status = response.status; error.code = body?.code; throw error;
  }
  if (typeof body?.data?.config_revision !== 'string') throw new Error('Invalid sports response');
  return body.data;
}
export async function getSportsSeasons(token, environment) {
  const data = await request(SPORTS_SEASONS_PATH, { method: 'GET' }, token, environment);
  if (!Array.isArray(data.seasons)) throw new Error('Invalid sports season list');
  return data;
}
export async function getSportsSeason(id, token, environment) {
  const data = await request(`${SPORTS_SEASONS_PATH}/${encodeURIComponent(id)}`, { method: 'GET' }, token, environment);
  if (!data.season || !Array.isArray(data.season.games)) throw new Error('Invalid sports season');
  return data;
}
export function mutateSportsSeason(operation, token, environment) {
  if (!['draft', 'review', 'publish', 'unpublish', 'include', 'exclude'].includes(operation.kind) || !operation.id || !operation.revision || !operation.operationId) throw new Error('Missing sports mutation precondition');
  if (['include', 'exclude'].includes(operation.kind) && (!Array.isArray(operation.input?.game_ids) || !operation.input.game_ids.length || new Set(operation.input.game_ids).size !== operation.input.game_ids.length)) throw new Error('Select at least one explicit game ID');
  return request(`${SPORTS_SEASONS_PATH}/${encodeURIComponent(operation.id)}/${operation.kind}`, {
    method: 'POST', headers: { 'If-Match': `"${operation.revision}"`, 'X-Operation-Id': operation.operationId }, body: JSON.stringify(operation.input || {}),
  }, token, environment);
}

export const SPORTS_PROMOTION_CONFIRMATION = 'PROMOTE TEST PUBLICATION TO PROD';
export const sportsPromotionReady = () => process.env.REACT_APP_SPORTS_PROD_PROMOTION_ENABLED === 'true';
async function promotionRequest(path, options, token, ready, responseKind = 'revision') {
  if (!ready || getSelectedEnvironment() !== 'prod') throw new Error('Sports promotion is not ready in the selected PROD environment.');
  const response = await requestAuthAdmin(`${path}?environment=prod`, options, token);
  let body;
  try { body = await response.json(); } catch { throw new Error(`Sports response unavailable (${response.status})`); }
  if (!response.ok) { const failure = new Error(body?.msg || `Sports request failed (${response.status})`); failure.status = response.status; failure.code = body?.code; throw failure; }
  if (responseKind === 'preview') {
    const preview = body?.data?.promotion_preview;
    if (!preview || typeof preview.expected_target_revision !== 'string' || !preview.expected_target_revision) throw new Error('Invalid sports promotion preview');
  } else if (typeof body?.data?.config_revision !== 'string') throw new Error('Invalid sports response');
  return body.data;
}
export async function getSportsPromotionTarget(id, token, ready = sportsPromotionReady()) {
  const list = await promotionRequest(SPORTS_SEASONS_PATH, { method: 'GET' }, token, ready);
  if (!Array.isArray(list.seasons)) throw new Error('Invalid sports season list');
  if (!list.seasons.some(season => season.id === id)) return { config_revision: list.config_revision, published_games: [] };
  return promotionRequest(`${SPORTS_SEASONS_PATH}/${encodeURIComponent(id)}`, { method: 'GET' }, token, ready);
}
export function mutateSportsPromotion(operation, token, ready = sportsPromotionReady()) {
  if (!['promotion-preview', 'promote'].includes(operation.kind) || !operation.id || !operation.revision || !operation.operationId || !operation.input?.source_revision || !operation.input?.plaza_mapping) throw new Error('Missing sports promotion precondition');
  if (operation.kind === 'promote' && (!operation.input.preview_sha256 || operation.input.confirmation !== SPORTS_PROMOTION_CONFIRMATION)) throw new Error('Missing exact promotion confirmation');
  return promotionRequest(`${SPORTS_SEASONS_PATH}/${encodeURIComponent(operation.id)}/${operation.kind}`, {
    method: 'POST', headers: { 'If-Match': `"${operation.revision}"`, 'X-Operation-Id': operation.operationId }, body: JSON.stringify(operation.input),
  }, token, ready, operation.kind === 'promotion-preview' ? 'preview' : 'revision');
}
